/* eslint-disable react/no-danger */
import { m } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid } from '@mui/material';
import { PropTypes } from 'prop-types';

//  import { varFade } from '../../animate';
import MotionViewport from '../../animate/MotionViewport';

DetailIframe.propTypes = {
  text: PropTypes.any,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 0),
  backgroundColor: theme.palette.background.paper,
}));

const DivStyle = styled('div')(({ theme }) => ({
  '& a': {
    color: theme.palette.mode === 'light' ? '#000' : '#FFC425',
  },
}));

export default function DetailIframe({ text }) {
  // eslint-disable-next-line no-return-assign

  const decodedText = text.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  const sanitizedText = decodedText.replace(
    /\s+(?:mozallowfullscreen|webkitallowfullscreen|execution-while-out-of-viewport|execution-while-not-rendered|web-share|xr-spatial-tracking|autoplay|autoplay;|allowfullscreen|autostart)(?:="[^"]*")?/gi,
    ''
  );
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = sanitizedText;

  const iframes = tempDiv.querySelectorAll('iframe');
  iframes?.forEach((iframe) => {
    const src = iframe.getAttribute('src');
    if (src && src.includes('/embed')) {
      const newSrc = src.substring(0, src.indexOf('/embed') + '/embed'.length);
      iframe.setAttribute('src', newSrc);
      [
        'mozallowfullscreen',
        'webkitallowfullscreen',
        'execution-while-out-of-viewport',
        'execution-while-not-rendered',
        'web-share',
        'xr-spatial-tracking',
        'autoplay',
        'allowfullscreen',
        'autostart',
      ].forEach((attribute) => {
        iframe.removeAttribute(attribute);
      });

      iframe.removeAttribute('allow');
    }
  });

  const sanitizedTextMain = tempDiv.innerHTML;

  return (
    <RootStyle className="printable">
      <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
        <m.div /*   variants={varFade().inUp}   */>
          <Grid container>
            <Grid
              item
              xs={12}
              sx={{
                textAlign: 'justify',
                color: 'text.primary',
              }}
            >
              <DivStyle
                id="decoded-text"
                className="article-iframe-wrapper"
                dangerouslySetInnerHTML={{
                  __html: sanitizedTextMain,
                }}
              />
            </Grid>
          </Grid>
        </m.div>
      </Container>
    </RootStyle>
  );
}
